/**
 * 不要自己在外部实例化ClickDelegate，使用静态方法createListener()来使用这个类
 * 例如:
 * elIframe.contentDocument.onclick
 *  = ClickDelegate.createListener((count) => {
 *      if (count === 1) {
 *        that.$emit('onpageclick')
 *      }
 *    })
 */
export default class ClickDelegate {
  constructor (callback) {
    this.callback = callback
    this.count = 0
  }

  /**
   * 返回一个点击事件监听器
   * @param {count} callback 回调返回告知被连续点击了多少次
   */
  static createListener (callback) {
    let that = new ClickDelegate(callback)
    return function () {
      that._handleClick()
    }
  }

  _handleClick () {
    this.count++
    let promise = new Promise((resolve, reject) => {
      setTimeout(resolve, 200, this.count)
    })

    promise.then((count) => {
      if (count === this.count) {
        this.callback(count)
        this.count = 0
      }
    })
  }
}
